module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "document-container columns"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRequisite(_vm.object.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-data"
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'id_' + _vm.object.id
    },
    on: {
      "blur": _vm.handleUpdate,
      "click": function($event) {}
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b16dbad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/RequisiteItem.vue
// module id = 992
// module chunks = 0